import { connect } from 'react-redux';
import { setCountry, setProvinceState, setCity, setAddress, setPostalCode, clearShippingInfo } from 'Actions/shipping';
import { updateValids } from 'Actions/form';
import ShippingForm from './Shipping';

const mapStateToProps = (state) => ({
    country: state.shipping.country,
    provinceState: state.shipping.provinceState,
    city: state.shipping.city,
    address: state.shipping.address,
    postalCode: state.shipping.postalCode,
    valids: state.form.valids,
    nextAttempted: state.form.nextAttempted
})

const mapDispatchToProps = (dispatch) => ({
    setCountry: (country) => dispatch(setCountry(country)),
    setProvinceState: (provinceState) => dispatch(setProvinceState(provinceState)),
    setCity: (city) => dispatch(setCity(city)),
    setAddress: (address) => dispatch(setAddress(address)),
    setPostalCode: (postal_code) => dispatch(setPostalCode(postal_code)),
    clearShippingInfo: () => dispatch(clearShippingInfo()),
    updateValids: (new_valids) => dispatch(updateValids(new_valids))
})

export default connect(mapStateToProps, mapDispatchToProps)(ShippingForm);